import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { connect } from 'react-redux';
import { FlexRow, BreadCrumb } from '@bart.sk-eshop/eshop-defaults';
import { __, __r } from '@bart.sk-eshop/react-i18n';
import { breadCrumbSelector, BreadCrumbPath } from './breadCrumbSlice';
import { withRouter, WithRouterProps } from 'react-router';
import { BreadcrumbMicrodata } from '../../components/_helpers/Microdata/Microdata';
import {
  getLangAbsoluteUrl,
  shouldNoIndexByPathname,
} from '../../utilities/metatags';

interface Props {
  breadCrumb: BreadCrumbPath;
  lang: string;
}

function BreadCrumbContainer({
  breadCrumb,
  lang,
  location,
}: Props & WithRouterProps) {
  const isCheckoutRoute =
    location.pathname === __r('routes:kosik/pokladna', '/kosik/pokladna');
  const showBreadCrumbs =
    breadCrumb && breadCrumb.length > 0 && !isCheckoutRoute;

  const normalizedBreadCrumb = breadCrumb?.map(item => ({
    ...item,
    url:
      typeof item.url === 'string' && !item.url.startsWith('/')
        ? `/${item.url}`
        : item.url,
  }));

  const microdataItems =
    showBreadCrumbs && !shouldNoIndexByPathname(location.pathname)
      ? [
          { name: __('Domov'), url: getLangAbsoluteUrl('', lang) },
          ...normalizedBreadCrumb.map((item, index) => ({
            name: item.name,
            url:
              item.url && index !== normalizedBreadCrumb.length - 1
                ? getLangAbsoluteUrl(item.url, lang)
                : '',
          })),
        ]
      : [];

  return (
    <>
      {microdataItems.length > 0 && (
        <BreadcrumbMicrodata items={microdataItems} />
      )}
      {showBreadCrumbs && (
        <Wrapper>
          <BreadCrumb breadCrumb={normalizedBreadCrumb} />
        </Wrapper>
      )}
    </>
  );
}

const Wrapper = styled(FlexRow)`
  margin: 0 auto;
  width: 100%;
  border-bottom: ${({ theme }) => theme.borders.primary};

  ${({ theme }) => theme.mediab.m580`
  `}
`;

const mapStateToProps = state => {
  return {
    breadCrumb: breadCrumbSelector(state),
    lang: state.general.lang,
  };
};

export default connect(mapStateToProps)(withRouter(BreadCrumbContainer));
